import '@bootstrappers/filters';
import '@bootstrappers/helpers';
import '@bootstrappers/notifications';
import '@bootstrappers/ui-components';
import Vue from 'vue';

Vue.prototype.console = window.console;

window.Vue = Vue;
//github.com/vuejs/vue-devtools
https: Vue.config.devtools = true;
// https://github.com/vue-perf-devtool/vue-perf-devtool
Vue.config.performance = true;
Vue.config.productionTip = false;

export default Vue;
